import React from 'react';
import { Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import './Book.css'
import axios from 'axios';

function Book(props) {
  const navigate = useNavigate();
    const {_id, name, author, description, price, image} = props.book;

    const deleteHandler = async () => {
      await axios.delete(`https://bookstore-hyob.onrender.com/books/${_id}`).then((res) => res.data).then(()=> navigate("/")).then(() => navigate("/books"))
    }
  return (
    <div className='card'>
        <img src={image} alt={name} />
        <article>By {author}</article>
        <h3>{name}</h3>
        <p>{description}</p>
        <h2>Rs {price}</h2>
        <Button LinkComponent={Link} to={`/books/${_id}`} sx={{mt: '15'}}>Update</Button>
        <Button onClick={deleteHandler} sx={{mt: '10'}}>Delete</Button>      
    </div>
  )
}

export default Book;